import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    });
  }, []);

  const applySession = useCallback((data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const login = useCallback(
    async (identifier, password) => applySession((await api.post("/auth/login", { identifier, password })).data),
    [applySession]
  );

  const register = useCallback(
    async (formData) => applySession((await api.post("/auth/register", formData)).data),
    [applySession]
  );

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  const refresh = useCallback(() => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {}), []);

  const value = useMemo(() => ({ user, setUser, refresh, login, register, logout }), [user, refresh, login, register, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
